export default __webpack_public_path__ + "static/media/IkonGroenOmstilling.c69cb83f.svg";